import {connect} from 'react-redux';
import {Platform} from 'react-native';
import { CommonActions } from '@react-navigation/native';
import Navigation from '../../../lib/navigation';
import ESimCheck from './ESimCheck';
import {goToNextOrderPage} from '../../../modules/SignUp';
import {isLoggedInSelector} from '../../../modules/Authentication';

const mapStateToProps = state => ({
  nextPage: !isLoggedInSelector(state)
    ? 'createAccount'
    : Platform.OS === 'web'
      ? 'identityRequirements'
      : '',
});

const mapDispatchToProps = dispatch => ({
  goTo: (routeName?: string) => {
    dispatch(goToNextOrderPage(routeName));
  },
  goToSelectSubscriptionToSimSwap: () => {
    Navigation.dispatch(CommonActions.navigate({name: 'selectSubscriptionToSwapSim'}));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ESimCheck);